import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InformationToolTipComponent } from './information-tool-tip.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [InformationToolTipComponent],
  exports: [InformationToolTipComponent]
})
export class InformationToolTipModule { }
